<style lang="scss" scoped>
@import "core";

.dn-db-downloader {
  background: #fff;
  border: solid 2px $color-primary;
  padding: 28px 20px;

  &__lead {
    color: #f09405;
    text-align: center;
    font-weight: bold;
    font-size: inherit;
  }

  &--has-update {

    .dn-db-downloader__lead {
    }
  }

  &--has-missing {
    text-align: center;

    .dn-db-downloader__lead {
    }

    .my-message {
      display: inline-block;
      text-align: left;
    }
  }
}

.my-about-data {
  font-size: 90%;

  p {
    margin-top: 10px;
    text-indent: -1em;
    padding-left: 1em;

    &:before {
      content: "・";
    }
  }
}

.my-message {
  margin-top: 20px;
  font-size: 90%;
  text-align: center;
}

.my-actions {
  margin-top: 20px;
  text-align: center;

  @include mq(sp) {
    display: flex;
    flex-direction: column-reverse;
  }
}

.my-btn-download {
  @include mq(pc) {
    min-width: 200px;
    margin-left: 15px;
  }

  @include mq(sp) {
    margin-bottom: 20px;
  }
}
</style>

<template>
  <div :class="classes" v-if="false">
    <p class="dn-db-downloader__lead">
      <span v-if="hasNotexist">このページを閲覧するには<wbr>データのダウンロードが<wbr>必要です</span>
      <span v-if="hasUpdate">このページのデータに<wbr>更新があります。</span>
      <span v-if="hasMissing">データの再ダウンロードが<wbr>必要です</span>
    </p>
    <div class="my-message">
      <div v-if="hasUpdate">
        <p>再度データをダウンロードしてください。</p>
      </div>
      <div v-if="hasMissing">
        <p>このメッセージが表示される場合以下の原因が考えられます。</p>
        <ul class="mt10">
          <li>・当サイトを含む過去閲覧されたサイトでの保存データが増えた</li>
          <li>・お使いの端末のストレージの空き容量が不足した</li>
        </ul>
      </div>
    </div>
    <div class="my-actions">
      <dn-btn class="my-btn-about dn-btn--block-sp" @click.native.stop="showAbout">データについて</dn-btn>
      <dn-btn class="my-btn-download dn-btn--block-sp" primary @click.native.stop="download">
        {{hasUpdate ? '更新' : 'ダウンロード'}}する
      </dn-btn>
    </div>

    <dn-dialog ref="dialog-about">
      <h3 slot="header">ダウンロードデータについて</h3>
      <div class="my-about-data">
        <p>お使いの端末の空き容量が不足している場合、データのダウンロードができない場合があります。<br>不要なデータを削除の上再度お試し頂くか、十分な空き容量のある端末でお試しください。</p>
        <p>一度ダウンロードしたデータは、お使いの端末の空き容量が少なくなった際、ブラウザによって自動的に削除される事があります。<br>再度ダウンロードをお試しください。</p>
        <p>Internet Explorerをお使いの場合、データダウンロード中に画面下部に容量拡張を許可するためのダイアログが表示される事があります。このダイアログが表示された場合「はい」を押して容量の拡張を許可してください。<br>この許可を行わずにダイアログを閉じるとダウンロードが行えません。</p>
        <p>Cookie等のブラウザのストレージ機能を有効にしておかないと、正常にダウンロードできない可能性があります。</p>
        <p>プライベートブラウズモードでは、正常にダウンロードできない可能性があります。</p>
      </div>
      <div slot="footer">
        <dn-btn class="dn-btn--block-sp" @click.native.stop="hideAbout">閉じる</dn-btn>
      </div>
    </dn-dialog>
  </div>
</template>



<script>
export default {
  props: {
    status: {
      type: Object,
      default: {},
    },

    target: {
      type: [Array, String],
      required: true,
    },

    autoRequire: {
      type: Boolean,
      default: true,
    },
  },


  model: {
    prop: 'status',
    event: 'change',
  },


  data() {
    return {
      statusName: 'pending',
      progress: 0,
    }
  },



  computed: {
    classes() {
      return {
        'dn-db-downloader': true,
        'dn-db-downloader--has-update': this.hasUpdate,
        'dn-db-downloader--has-missing': this.hasMissing,
        'dn-db-downloader--has-notexist': this.hasNotexist,
        'dn-db-downloader--has-data': this.hasData,
      }
    },
    targetTables() { return typeof this.target === 'string' ? [this.target] : this.target },
    isPending()   { return this.statusName === 'pending' },
    isReady()     { return this.statusName === 'exist' },
    hasUpdate()   { return this.statusName === 'update' },
    hasMissing()  { return this.statusName === 'missing' },
    hasNotexist() { return this.statusName === 'notexist' },
    needShow()    { return !this.isReady && !this.isPending },
    hasData()     { return !this.hasMissing && !this.hasNotexist },
    computedStatus() {
      return {
        result     : this.statusName,
        isPending  : this.isPending,
        isReady    : this.isReady,
        hasUpdate  : this.hasUpdate,
        hasMissing : this.hasMissing,
        hasNotexist: this.hasNotexist,
        needShow   : this.needShow,
        hasData    : this.hasData,
        progress   : this.progress,
      }
    },
  },



  mounted() {
    if (this.autoRequire) this.require();
  },



  watch: {
    statusName(a) {
      this.$emit('change', this.computedStatus);
      if (this.hasData) this.$emit('data-ready');
    },

    progress() {
      this.$emit('change', this.computedStatus);
    },
  },



  methods: {
    async require() {
      dn.loading.show();

      try {
        const status = await dn.db.getTablesStatus(this.targetTables);
        this.statusName = status.result;
        if (this.needShow) {
          await this.download();
        }
      } catch(e) {
        dn.loading.hide();
        throw new Error(e);
      }

      dn.loading.hide();
    },

    async download() {
      const downloadResult = await dn.db.download(this.targetTables, {
        onProgress: e => { this.progress = e.value },
      });
      this.statusName = 'exist';
      this.$emit('download');
    },

    showAbout() {
      return this.$refs['dialog-about'].show();
    },

    hideAbout() {
      return this.$refs['dialog-about'].hide();
    },
  },
}
</script>


// WEBPACK FOOTER //
// DbDownloader.vue?26be3e99